/* eslint-disable @typescript-eslint/no-explicit-any */
import { create } from 'zustand'

interface State {
  dataMap: Map<string, any>
}

export const useDataStore = create<State>()(() => ({
  dataMap: new Map(),
}))

export const setStoreData = (key: string, value: any) => {
  useDataStore.setState(prev => ({ dataMap: new Map(prev.dataMap).set(key, value) }))
}

export const getStoreData = (key?: string) => {
  if (key) {
    return useDataStore.getState().dataMap.get(key)
  }
}
